export function getPhotoUrl(photo: string | null | undefined, size: string): string | null {
    if(!photo) {
        return null;
    }
    return photo + size;
}
